let _data;

const redirect = {
  set: redirectObj => (_data = redirectObj),
  get: () => _data,
  formFullPath: () => `${_data.pathname}${_data.search}`,
  valid: () => {
    const validPaths = ['bookings', 'account'];
    return validPaths.map(path => _data.pathname.includes(path)).includes(true);
  }
};

Object.freeze(redirect);
export default redirect;
